export const sftpWarningCopy =
  'Your company has turned on SFTP, be sure to add the new employee to your CSV after, or they will be deleted.';
